module.exports = ":host {\n  position: relative; }\n\n.portlet-progress {\n  margin: 1px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/plugins/templates/empty/empty.component.scss
// module id = ./libs/chassis-core/src/app/plugins/templates/empty/empty.component.scss
// module chunks = main